import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d01314a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question-label" }, "Adjust both sliders until the text below is most comfortable to read. Then select the “Next” button to submit.", -1))
const _hoisted_3 = { class: "mt-12 p-10 rounded-md flex items-center border border-aph-gray" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question-label" }, "Select the version that you find easier to read:", -1))
const _hoisted_6 = ["id", "name"]
const _hoisted_7 = ["for"]
const _hoisted_8 = ["id", "name"]
const _hoisted_9 = ["for"]
const _hoisted_10 = { class: "text-red-500 text-2xl font-bold text-center mt-2" }
const _hoisted_11 = { class: "flex justify-between mt-12" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "16",
  viewBox: "0 0 12 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.2299 1.24994L11.2299 14.7499C11.2295 14.8866 11.1918 15.0206 11.1209 15.1374C11.05 15.2543 10.9486 15.3496 10.8275 15.4131C10.7065 15.4766 10.5704 15.5059 10.434 15.4978C10.2975 15.4897 10.1659 15.4445 10.0532 15.3672L0.303188 8.61719C-0.101062 8.33744 -0.101062 7.66394 0.303188 7.38344L10.0532 0.633442C10.1656 0.55531 10.2974 0.509492 10.434 0.500965C10.5707 0.492439 10.7071 0.521529 10.8284 0.585077C10.9497 0.648625 11.0513 0.744198 11.122 0.861415C11.1928 0.978631 11.2302 1.11301 11.2299 1.24994Z",
    fill: "black"
  })
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "16",
  viewBox: "0 0 12 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.750044 1.24994L0.750043 14.7499C0.750471 14.8866 0.788168 15.0206 0.859077 15.1374C0.929984 15.2543 1.03142 15.3496 1.15246 15.4131C1.2735 15.4766 1.40956 15.5059 1.546 15.4978C1.68245 15.4897 1.8141 15.4445 1.92679 15.3672L11.6768 8.61719C12.081 8.33744 12.081 7.66394 11.6768 7.38344L1.92679 0.633442C1.81434 0.55531 1.68262 0.509492 1.54595 0.500965C1.40928 0.492439 1.27289 0.521529 1.15159 0.585077C1.03029 0.648625 0.928728 0.744198 0.857935 0.861415C0.787143 0.978631 0.749827 1.11301 0.750044 1.24994Z",
    fill: "white"
  })
], -1))

import { watch, ref, computed, defineModel } from "vue";
import { CheckCircleIcon } from '@heroicons/vue/24/solid';
import CircleIcon from './Icons/CircleIcon.vue';
import SliderInput from './SliderInput.vue';
import PrimaryButton from './PrimaryButton.vue';
import SecondaryButton from './SecondaryButton.vue';
import { useStore } from 'vuex';

const weightMin = 0;
const weightMax = 1000;
const widthMin = 0;
const widthMax = 1000;


export default /*#__PURE__*/_defineComponent({
  __name: 'Question',
  props: {
    question: Object,
    textSnippets: [Object],
    isLastQuestion: Boolean,
},
  emits: ["previousPage", "nextPage", "update:usedTextSnippets"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;



const selectedAB = ref('');
const showErrorMessage = ref(false);
const store = useStore();

const isExploratory = computed(() => {
    return props.question?.option?.length === 1 && props.question.option[0].variable_sliders;
});

const getRandomValue = (min, max, step) => {
  const steps = Math.floor((max - min) / step) + 1;
  const randomStep = Math.floor(Math.random() * steps);
  const randomValue = min + randomStep * step;

  return randomValue;
}

const fontWeightA = getRandomValue(weightMin, weightMax, 1);
const fontWidthA = getRandomValue(widthMin, widthMax, 1);
const fontWeightB = getRandomValue(weightMin, weightMax, 1);
const fontWidthB = getRandomValue(widthMin, widthMax, 1);

const fontWeight = ref(fontWeightA);
const fontWidth = ref(fontWidthA);

const getStyle = (option, fontWeight, fontWidth) => {
    const style = {
        'font-family': `"${option.font}", sans-serif`,
    };

    const fontVariationSettings = [];
    if (option.random_font_weight || option.variable_sliders) {
        fontVariationSettings.push(`"wght" ${fontWeight}`);
    }

    if (option.random_font_width || option.variable_sliders) {
        fontVariationSettings.push(`"wdth" ${fontWidth}`);
    }

    if (fontVariationSettings.length) {
        style['font-variation-settings'] = fontVariationSettings.join(', ');
    }

    if (option.font_leading) {
        style['line-height'] = `${option.font_leading}px`;
    }

    if (option.font_tracking) {
        style['letter-spacing'] = `${option.font_tracking}px`;
    }

    return style;
}

const aStyle = computed(() => {
    if (props.question.option.length > 0) {
        return getStyle(props.question.option[0], fontWeightA, fontWidthA);
    }
    return {};
});

const bStyle = computed(() => {
    if (props.question.option.length > 1) {
        return getStyle(props.question.option[1], fontWeightB, fontWidthB);
    }
    return {};
});

const exploratoryStyle = computed(() => {
    if (props.question.option.length === 1) {
        return getStyle(props.question.option[0], fontWeight.value, fontWidth.value, 0);
    }
    return {};
});

let _textSnippet;

function getRandomTextSnippet(option) {
    if (_textSnippet) {
        return _textSnippet;
    }

    const filteredArray = props.textSnippets.filter(item => {
        return item.aph_text_length === option.text_length && !store.state.textSnippets.includes(item)
    });

    if (filteredArray.length === 0) {
        return null;
    }

    const randomIndex = Math.floor(Math.random() * filteredArray.length);

    const selectedSnippet = filteredArray[randomIndex];

    store.dispatch('addSnippet', selectedSnippet);

    _textSnippet = selectedSnippet;

    return selectedSnippet;
}

const abText = computed(() => {
    if (props.question.option.length > 0) {
        return getRandomTextSnippet(props.question.option[0]);
    }
    return {};
});

const exploratoryText = computed(() => {
    if (props.question.option.length === 1 && props.question.option[0].variable_sliders) {
        return getRandomTextSnippet(props.question.option[0]);
    }
    return {};
});

const isValid = () => {
    if (!isExploratory.value) {
        return selectedAB.value !== '';
    }
    return true;
}

const response = computed(() => {
    if (isExploratory.value) {
        return {
            questionId: props.question.id,
            startFontWeight: fontWeightA,
            startFontWidth: fontWidthA,
            userFontWeight: fontWeight.value,
            userFontWidth: fontWidth.value,
            textId: exploratoryText.value.aph_text_id,
        };
    }
    if (selectedAB.value) {
        return {
            questionId: props.question.id,
            textIdA: abText.value?.aph_text_id,
            fontWeightA,
            fontWidthA,
            textIdB: abText.value?.aph_text_id,
            fontWeightB,
            fontWidthB,
            selected: selectedAB.value,
        };
    }
    return {
        questionId: props.question.id,
    };
});

__expose({
    response,
});



const back = () => {
    showErrorMessage.value = false;
    emit('previousPage');
};

const next = () => {
    if (isValid()) {
        showErrorMessage.value = false;
        emit('nextPage');
    } else {
        showErrorMessage.value = true;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      (isExploratory.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", null, [
              _createVNode(SliderInput, {
                min: weightMin,
                max: weightMax,
                label: "Weight",
                modelValue: fontWeight.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fontWeight).value = $event)),
                class: "mb-10"
              }, null, 8, ["modelValue"]),
              _createVNode(SliderInput, {
                min: widthMin,
                max: widthMax,
                label: "Width",
                modelValue: fontWidth.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fontWidth).value = $event)),
                class: "mb-10"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", {
                  class: "question-text",
                  style: _normalizeStyle(exploratoryStyle.value)
                }, _toDisplayString(exploratoryText.value?.aph_text), 5)
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                class: _normalizeClass(["question-input mb-10", {'question-selected': selectedAB.value === 'a'}])
              }, [
                _withDirectives(_createElementVNode("input", {
                  id: `ab_a_${__props.question.id}`,
                  type: "radio",
                  name: `ab_question_${__props.question.id}`,
                  value: "a",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedAB).value = $event))
                }, null, 8, _hoisted_6), [
                  [_vModelRadio, selectedAB.value]
                ]),
                _createElementVNode("label", {
                  class: "flex-1",
                  for: `ab_a_${__props.question.id}`
                }, [
                  _createElementVNode("span", {
                    class: "question-text",
                    style: _normalizeStyle(aStyle.value)
                  }, _toDisplayString(abText.value?.aph_text), 5)
                ], 8, _hoisted_7)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["question-input", {'question-selected': selectedAB.value === 'b'}])
              }, [
                _withDirectives(_createElementVNode("input", {
                  id: `ab_b_${__props.question.id}`,
                  type: "radio",
                  name: `ab_question_${__props.question.id}`,
                  value: "b",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedAB).value = $event))
                }, null, 8, _hoisted_8), [
                  [_vModelRadio, selectedAB.value]
                ]),
                _createElementVNode("label", {
                  class: "flex-1",
                  for: `ab_b_${__props.question.id}`
                }, [
                  _createElementVNode("span", {
                    class: "question-text",
                    style: _normalizeStyle(bStyle.value)
                  }, _toDisplayString(abText.value?.aph_text), 5)
                ], 8, _hoisted_9)
              ], 2)
            ])
          ]))
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_10, "Please choose an option to continue", 512), [
      [_vShow, showErrorMessage.value]
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(SecondaryButton, { onClick: back }, {
        default: _withCtx(() => [
          _hoisted_12,
          _createTextVNode(" Back ")
        ]),
        _: 1
      }),
      _createVNode(PrimaryButton, { onClick: next }, {
        default: _withCtx(() => [
          (__props.isLastQuestion)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("Finish Test")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("Next")
              ], 64)),
          _hoisted_13
        ]),
        _: 1
      })
    ])
  ]))
}
}

})